import { getAvailableDynamicInputs } from 'services/alerts/dynamicInputs';

/**
 * Scan text for $placeholder patterns and return any that are
 * incompatible with the given trigger field.
 * Returns array of { placeholder: '$celsius', field: 'contact' }
 */
export const findIncompatiblePlaceholders = (text, triggerField, options = {}) => {
    if (!text || !triggerField) return [];

    // Match $word patterns but not $label.xxx (label lookups are always valid)
    const matches = text.match(/\$([a-zA-Z]+)(?![a-zA-Z.])/g) || [];
    const placeholders = [...new Set(matches.map(m => m.substring(1)))];

    const available = getAvailableDynamicInputs(triggerField, options).map(([key]) => key);

    return placeholders
        .filter(p => !available.includes(p))
        .map(p => ({ placeholder: `$${p}`, field: triggerField }));
};
